import React, { useEffect, useRef, useState } from "react";

const LazyLoad = ({ children, jsFile, cssFile }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once loaded

          // Load the JavaScript file
          if (jsFile) {
            const script = document.createElement("script");
            script.src = jsFile;
            script.defer = true;
            document.head.appendChild(script);
          }

          // Load the CSS file
          if (cssFile) {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = cssFile;
            document.head.appendChild(link);
          }
        }
      },
      { threshold: 0.1 } // Adjust threshold as needed
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [jsFile, cssFile]);

  return (
    <div ref={ref}>
      {isVisible ? children : <div>Loading...</div>} {/* Fallback UI */}
    </div>
  );
};

export default LazyLoad;
